import EditNotesModal from './edit-notes-modal-container';

export default EditNotesModal;
